import React from 'react'
import Seo from '../Seo/Seo'
import { LuMapPin, LuMail, LuPhone } from 'react-icons/lu'

const Contact = () => {
  return (
    <>
      <Seo
        title='Contact Us | CLI'
        description='Get in touch with CLI at Kiran Arcade, HSR Layout, Bangalore. Call +91 96115 46444 or email contact@mindmatrix.io.'
        path='/contact'
      />
      <header className='page_hero'>
        <span className='home_eyebrow'>Contact us</span>
        <h1>Get in touch</h1>
        <p className='home_lead'>
          Whether you have questions, ideas or collaboration opportunities, feel free to reach out.
        </p>
      </header>

      <div className='page_body'>
        <div className='contact_grid'>
          <div className='bento_card'>
            <h2 className='bento_title'>Visit or call us</h2>

            <div className='contact_row'>
              <LuMapPin size={20} />
              <div>
                <strong>Location</strong>
                MindMatrix, Kiran Arcade, 4th Floor, Sector 1, HSR Layout, Bangalore, Karnataka, India
              </div>
            </div>
            <div className='contact_row'>
              <LuMail size={20} />
              <div>
                <strong>Email</strong>
                <a className='contact_link' href='mailto:contact@mindmatrix.io'>contact@mindmatrix.io</a>
              </div>
            </div>
            <div className='contact_row'>
              <LuPhone size={20} />
              <div>
                <strong>Phone</strong>
                <a className='contact_link' href='tel:+919611546444'>+91 96115 46444</a>
              </div>
            </div>

            <div className='contact_map'>
              <iframe
                title='location-map'
                src='https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1252.101925054701!2d77.65241917605968!3d12.915904533579507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1760432351237!5m2!1sen!2sin'
                width='100%'
                height='240'
                style={{ border: 0 }}
                allowFullScreen=''
                loading='lazy'
              ></iframe>
            </div>
          </div>

          <div className='bento_card'>
            <h2 className='bento_title'>Send a message</h2>
            <p className='bento_para' style={{ marginBottom: 20 }}>We'll get back to you as soon as we can.</p>

            <form className='contact_form'>
              <label>Name<input type='text' name='name' placeholder='Your name' required /></label>
              <label>Email<input type='email' name='email' placeholder='you@example.com' required /></label>
              <label>Message<textarea name='message' placeholder='How can we help?' rows='6' required></textarea></label>
              <button type='submit' className='btn btn_primary'>Send message</button>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contact
